module.exports = __webpack_public_path__ + "img/object_remove_src_2.b2984627.webp";